import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'commaStringToArray'
})
export class CommaStringToArrayPipe implements PipeTransform {

  transform(value: string): any { 
 
     var arr = value.split(',');

     return arr;
  }

}
